import { render } from "./shop-details-top.vue?vue&type=template&id=5304e772&scoped=true"
import script from "./shop-details-top.vue?vue&type=script&lang=js"
export * from "./shop-details-top.vue?vue&type=script&lang=js"

import "./shop-details-top.vue?vue&type=style&index=0&id=5304e772&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5304e772"]])

export default __exports__